// Route wrapper ensuring authenticated access.
import { useT } from '@/i18n/useT';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/features/auth/useAuth';

const ProtectedRoute = ({ children }) => {
  const t = useT();
  const { user, loading } = useAuth();

  if (loading) {
    return <div>{t('common.loading', 'Loading...')}</div>;
  }

  return user ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;
